<template>
  <div class="wrapper" v-loading="showLoading">
    <common-header url="routeMapping" />

    <table class="table center">
      <!-- 供应商基本信息 -->
      <sup-base-info
        v-model="showAddress"
        :details="formData"
        readonly
        @setOpertionNum="setOpertionNum"
      />

      <!-- 经营者信息 -->
      <sup-operators
        v-model="showAddress"
        :details="formData"
        readonly
        @setOpertionNum="setOpertionNum"
      />

      <!-- 紧急联系人 -->
      <sup-contacts :details="formData" readonly />

      <tr>
        <th colspan="10">已映射的渠道列表</th>
      </tr>
      <!-- <template v-for="(item, index) of details.factoringBankRespList">
        <tr :key="index">
          <td>映射渠道</td>
          <td>
            <el-input :value="item.bankName" readonly />
          </td>
          <td>渠道简称</td>
          <td>
            <el-input :value="item.avcName" readonly />
          </td>
          <td>映射时间</td>
          <td colspan="5">
            <el-input :value="item.time" readonly />
          </td>
        </tr>
      </template> -->
      <tr>
        <td colspan="10">
          <template>
            <el-table
              :data="tableData"
              :header-cell-style="{ 'text-align': 'center' }"
              :cell-style="{ 'text-align': 'center' }"
              class="table-content"
              border
            >
              <table-column type="index" width="80" label="序号">
              </table-column>
              <table-column prop="bankName" label="映射渠道"> </table-column>
              <table-column prop="sendTime" label="映射时间">
                <template slot-scope="scope">
                  <date-picker v-model="scope.row.sendTime" time readonly />
                </template>
              </table-column>
              <table-column prop="reviewSt" label="映射状态">
                <template slot-scope="scope">
                  <span>{{ scope.row.reviewSt | filterStatus }}</span>
                </template>
              </table-column>
              <table-column prop="respMsg" label="映射返回"> </table-column>
              <table-column prop="count" label="交易成功的次数"> </table-column>
            </el-table>
          </template>
        </td>
      </tr>
      <!-- <tr>
        <td>交易次数</td>
        <td>
          <el-input :value="transaction.cumulativeNumber" readonly />
        </td>
        <td>累积合计</td>
        <td colspan="7">
          <el-input :value="transaction.totalTransaction" readonly />
        </td>
      </tr> -->
    </table>
  </div>
</template>

<script>
import SupBaseInfo from '@/components/DetailsSupplier/BaseInfo'
import SupOperators from '@/components/DetailsSupplier/Operators'
import SupContacts from '@/components/DetailsSupplier/Contacts'
export default {
  components: {
    SupBaseInfo,
    SupOperators,
    SupContacts
  },
  props: ['id'],

  data() {
    return {
      showAddress: false,
      details: {}, // 详情信息
      transaction: {}, // 交易信息
      formData: {},
      showLoading: false,
      tableData: [
        // {
        //   bankName: '新东方',
        //   time: '2021-04-20 22:22:22',
        //   status: 1,
        //   result: '映射成功的原因',
        //   count: 2
        // },
        // {
        //   bankName: '新东方',
        //   time: '2021-04-20 22:22:22',
        //   status: 1,
        //   result: '映射成功的原因',
        //   count: 2
        // }
      ]
    }
  },
  filters: {
    filterStatus(num) {
      return {
        '': '-',
        null: '-',
        1: '等待反馈',
        2: '注册成功',
        3: '注册失败'
      }[num]
    }
  },
  created() {
    this.getSupplierDetails()
    this.getSupplierCheckDeatils()
  },

  methods: {
    setOpertionNum(num) {
      this.details.opertionNum = num
    },
    getSupplierDetails() {
      const {
        id,
        $store: { dispatch }
      } = this
      const dispatchEvent = 'T4/routeMapping/getSupplierDetails'

      this.showLoading = true
      dispatch(dispatchEvent, { id: id }).then(res => {
        // factoringBankRespList 已映射的渠道列表
        this.formData = res.detailsRespVo
        if (res.supplierBanks) {
          this.tableData = res.supplierBanks
        }
        // this.transaction = res[2]
        this.showLoading = false
        console.log(JSON.parse(JSON.stringify(res)), '供应商路由映射详情')
      })
    },

    // 供应商详情
    getSupplierCheckDeatils() {
      const {
        id,
        $store: { dispatch }
      } = this
      const dispatchEvent = 'T2/supplierCheck/getDetails'

      dispatch(dispatchEvent, id).then(res => {
        this.detail = res
        // this.formData = Object.assign(this.formData, this.merchantApplyData)
        // console.log(this.formData, 'aaaa')
        this.showLoading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/Common/detailsTable.scss';
/deep/ .table-content {
  height: 100% !important;
  th.gutter {
    display: table-cell !important;
  }
}
/deep/ .colorfule-date-picker .el-input[data-v-f57154f6] .el-input__inner {
  text-align: center;
}

#app .el-table {
  height: auto !important;
}
</style>
